// extracted by mini-css-extract-plugin
module.exports = {"solutions":"styles_solutions__EbSKs","solutions__title":"styles_solutions__title__bj5Wb","solutions__list":"styles_solutions__list__s_kAc"};